import type {
  components as definitions,
  paths,
} from "@securityjourney/svc-chores/dist/gen/chores.d.ts";

import { OpenApiFetchWrapper } from "./openApiFetchWrapper";

export type AssignmentModel =
  definitions["schemas"]["securityjourney.proto.chores.AssignmentModel"];
export type ChoreList = definitions["schemas"]["securityjourney.proto.chores.UserAssignments"];
export type Assessments =
  definitions["schemas"]["securityjourney.proto.chores.KnowledgeAssessmentsStatusResponse"];
export type AssessmentStatus =
  definitions["schemas"]["securityjourney.proto.chores.KnowledgeAssessmentStatusResponse"];
export type AvailableStatuses =
  definitions["schemas"]["securityjourney.proto.chores.ListOverallStatusFacetsResponse"];

export type ModifyLessonAssignmentBody = NonNullable<
  paths["/svc/chores/assignment/{uuid}/lesson"]["patch"]["requestBody"]
>["content"]["application/json"];

export type ChoresNotifyPreference =
  definitions["schemas"]["securityjourney.proto.chores.Notify.Preference"];

export class ChoresClient extends OpenApiFetchWrapper<paths> {
  constructor() {
    super();
  }

  // create or update the given assignment
  // Returns 409 Conflict if an assignment already exists in this tenant with the given name.
  async assign(assignment: AssignmentModel) {
    return await this.post("/svc/chores/assignment", { body: assignment });
  }

  async myChores(forTenant?: string) {
    return await this.get("/svc/chores/me", {
      params: { query: { forTenant } },
    });
  }

  async getChore(id: string) {
    return await this.get("/svc/chores/assignment/{uuid}", {
      params: { path: { uuid: id } },
    });
  }

  async resetAssignmentProgress(assignmentUuid: string, learnerUuid: string) {
    return await this.post("/svc/chores/assignment/{assignment_uuid}/reset", {
      params: { path: { assignment_uuid: assignmentUuid } },
      body: { learnerUuid },
    });
  }

  async getAvailableStatuses() {
    return await this.get("/svc/chores/facets/overall-status");
  }

  async getAssessments(tenant: string) {
    return await this.get("/svc/chores/{tenant}/knowledge-assessments/status", {
      params: { path: { tenant }, query: {} },
    });
  }

  async getAssessment(tenant: string, assessmentId: string) {
    return await this.get("/svc/chores/{tenant}/knowledge-assessments/{assessment_uuid}/status", {
      params: { path: { tenant, assessment_uuid: assessmentId } },
    });
  }

  async archive(id: string) {
    return await this.post("/svc/chores/assignment/{assignment_uuid}/archive", {
      params: { path: { assignment_uuid: id } },
    });
  }

  async modifyLessonAssignment(assignmentUuid: string, body: ModifyLessonAssignmentBody) {
    return await this.patch("/svc/chores/assignment/{uuid}/lesson", {
      params: { path: { uuid: assignmentUuid } },
      body,
    });
  }

  async unarchive(id: string) {
    return await this.post("/svc/chores/assignment/{assignment_uuid}/unarchive", {
      params: { path: { assignment_uuid: id } },
    });
  }
}
